import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC, useMemo, useState } from 'react';
import { MenuItem } from '../types';
import { Image } from '../../../components/Image';
import { STYLE_VARS } from '../../../constants/style-vars';
import { COLORS, FONTS } from '../../../constants';

interface MenuCollapseProps {
  menuItem: MenuItem;
}

const MenuCollapse: FC<MenuCollapseProps> = ({ menuItem }) => {
  const [open, setOpen] = useState<boolean>(false);
  const renderHeaderCollapse = useMemo(() => {
    return (
      <View>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingVertical: 5,
            alignItems: 'center',
          }}
        >
          <TouchableOpacity
            onPress={() => {
              if (menuItem.onPress !== undefined) {
                menuItem.onPress();
              }
            }}
          >
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <Image
                source={menuItem.icon}
                style={{
                  width: 20,
                  height: 20,
                  resizeMode: 'contain',
                  tintColor: STYLE_VARS.primaryColor,
                  marginRight: 10,
                }}
              />
              <Text style={styles.headerText}>{menuItem.title}</Text>
            </View>
          </TouchableOpacity>
          {menuItem.isCollapse == true && (
            <TouchableOpacity
              onPress={() => {
                setOpen(!open);
              }}
              style={{
                width: 30,
                height: 30,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Image
                source={
                  open == true
                    ? require('../../../assets/up-button.png')
                    : require('../../../assets/down-button.png')
                }
                style={{
                  width: 15,
                  height: 8,
                  // marginRight:isDesktop() ? 10 :  5,
                }}
              />
            </TouchableOpacity>
          )}
        </View>
      </View>
    );
  }, [menuItem, open]);

  const renderContent = useMemo(() => {
    if (open) {
      return (
        <View style={{}}>
          {menuItem.contents.map((content) => (
            <TouchableOpacity
              key={content.title}
              onPress={content.onPress}
              style={{ marginLeft: 30, paddingVertical: 7 }}
            >
              <Text style={styles.headerText}>{content.title}</Text>
            </TouchableOpacity>
          ))}
        </View>
      );
    }
  }, [open, menuItem.contents]);

  return (
    <View style={{ marginVertical: 5 }}>
      {renderHeaderCollapse}
      {renderContent}
    </View>
  );
};

export default MenuCollapse;

const styles = StyleSheet.create({
  headerText: {
    fontSize: 14,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: COLORS.GREEN,
    fontWeight: '500',
    fontFamily: FONTS.AvenirMedium,
  },
});
